﻿import React from "react";
import { ContainerAddressDto } from "../api/types";

interface FullAddressProps {
  address?: Partial<ContainerAddressDto>;
}

export function formatFullAddress(address?: Partial<ContainerAddressDto>) {
  if (!address) {
    return "";
  }

  return [address.street, address.zipCode, address.city, address.country]
    .filter((i) => i && i != "" && i != " ")
    .join(", ");
}

export default function (props: FullAddressProps) {
  const address = props.address;
  if (!address) {
    return <span />;
  }
  return <span style={{ minWidth: 300 }}>{formatFullAddress(address)}</span>;
}
